<template>
  <transition name="modal-fade">
  <div class="modal-backdrop">
    <div class="modal">
      <header class="modal-header">
        <slot name="header">
          Change version
        </slot>
        <button
          type="button"
          class="btn-close"
          @click="emitCloseModal"
        >
          x
        </button>
      </header>

      <section class="modal-body">
          <input type="text" v-model="modalData.inputText">
      </section>

      <footer class="modal-footer">
        <slot name="footer">
        </slot>
        <button
          type="button"
          class="btn-green"
          @click="emitChangeModal"
        >
          CHANGE
        </button>
      </footer>
    </div>
  </div>
  </transition>
</template>

<script>
  export default {
    name: 'Modal',
    props: ['modalData', 'originalValue'],
    methods: {
      emitCloseModal() {
        this.modalData = ''
        this.originalValue = ''
        this.$emit('close-modal');
      },
      emitChangeModal() {
        if(this.originalValue !== this.modalData.version)
          this.$emit('click-change-modal', this.modalData)
      },
    },
  };
</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .modal-header,
  .modal-footer {
    padding: 5px 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4787ff;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 5px 15px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 0px 5px;
    cursor: pointer;
    font-weight: bold;
    color: #4787ff;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: white;
    border: 1px solid #4787ff;
    border-radius: 2px;
    background-color: #4787ff;
    font-family: Roboto,Helvetica Neue,sans-serif;
    font-size: 14px;
    font-weight: 500;
  }
  
  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>